import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { Button, Input, Space, Typography } from "antd";
import { Controller, useForm } from "react-hook-form";

import { useAppDispatch } from "@/shared/lib/hooks";
import { getCoursesPage } from "@/shared/config";
import { setCredentials } from "../../model/authSlice";
import { useLoginMutation } from "../../api/authApi";

import styles from "./loginForm.module.scss";

const { Text } = Typography;

export const LoginForm = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const [login] = useLoginMutation();
  const {
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({
    defaultValues: {
      email: "",
      password: "",
    },
  });

  const onSubmit = handleSubmit(async (data) => {
    try {
      const response = await login(data).unwrap();
      dispatch(setCredentials(response));
      navigate(getCoursesPage(), { replace: true });
    } catch (error) {
      toast.error((error as any)?.data?.message || "Ошибка авторизации");
    }
  });

  return (
    <div className={styles.loginPage}>
      <div className={styles.loginContainer}>
        <h1>Вход в систему</h1>
        <form onSubmit={onSubmit} className={styles.loginForm}>
          <Space orientation="vertical" size={0}>
            <h5 className={styles.label}>Логин</h5>
            <Controller
              name="email"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Input
                  {...field}
                  status={errors.email && "error"}
                  size="large"
                  className={styles.Input}
                  placeholder="email"
                />
              )}
            />
            {errors.email && (
              <Text type="danger" className={styles.errorMessage}>
                Поле обязательно для заполнения
              </Text>
            )}
          </Space>
          <Space orientation="vertical" size={0}>
            <h5 className={styles.label}>Пароль</h5>
            <Controller
              name="password"
              control={control}
              rules={{ required: true }}
              render={({ field }) => (
                <Input.Password
                  {...field}
                  status={errors.password && "error"}
                  size="large"
                  className={styles.Input}
                  placeholder="password"
                />
              )}
            />
            {errors.password && (
              <Text type="danger" className={styles.errorMessage}>
                Поле обязательно для заполнения
              </Text>
            )}
          </Space>
          <Button
            type="primary"
            onClick={onSubmit}
            size="large"
            className={styles.loginButton}
          >
            Login
          </Button>
        </form>
      </div>
    </div>
  );
};
